// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "input[data-v-8d934dc8] {\n  font-family: var(--interfaceFontTypeface, inherit);\n  color: var(--interfaceFontColor, inherit);\n  font-weight: var(--interfaceFontWeight, inherit);\n}\ninput[type=\"date\"][data-v-8d934dc8] {\n  padding-left: 0.25rem;\n  padding-right: 0.25rem;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
